import { bool, number, shape, string } from 'prop-types'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { positionPropType } from '../common/position-prop-type'
import { locationDescriptionBasePropType } from './location-description-base-prop-type'

/**
 * @typedef {Object} TemperatureViolation
 * @property {string} violationId
 * @property {string} objectId
 * @property {string} sensorCode
 * @property {number} deviationMin
 * @property {number} deviationMax
 * @property {number} deviationAvg
 * @property {number} deviationRootMeanSquare
 * @property {number} deviationSquareSum
 * @property {number} deviationSum
 * @property {number} deviationCount
 * @property {number} lastValue
 * @property {bool} objectEventCreated
 * @property {string} sensorConfigId
 * @property {string} sensorName
 * @property {ISO8601} start
 * @property {number} startValue
 * @property {ISO8601} [end]
 * @property {number} [lowerThreshold]
 * @property {number} [upperThreshold]
 * @property {object} [startLocation]
 * @property {LocationDescriptionBase} [startLocation.locationDescription]
 * @property {Position} [startLocation.position]
 * @property {object} [endLocation]
 * @property {LocationDescriptionBase} [endLocation.locationDescription]
 * @property {Position} [endLocation.position]
 */
export const temperatureViolationPropType = shape({
    violationId: string.isRequired,
    objectId: string.isRequired,
    sensorCode: string.isRequired,
    deviationMin: number.isRequired,
    deviationMax: number.isRequired,
    deviationAvg: number.isRequired,
    deviationRootMeanSquare: number.isRequired,
    deviationSquareSum: number.isRequired,
    deviationSum: number.isRequired,
    deviationCount: number.isRequired,
    lastValue: number.isRequired,
    objectEventCreated: bool.isRequired,
    sensorConfigId: string.isRequired,
    sensorName: string.isRequired,
    start: iso8601PropType.isRequired,
    startValue: number.isRequired,
    end: iso8601PropType,
    lowerThreshold: number,
    upperThreshold: number,
    startLocation: shape({
        locationDescription: locationDescriptionBasePropType,
        position: positionPropType
    }),
    endLocation: shape({
        locationDescription: locationDescriptionBasePropType,
        position: positionPropType
    })
})
